import { IRelatedProduct } from 'models/BasicProduct';
import { RedDrawer } from 'components/Shared/Drawer';
import Spinner from 'components/Shared/Loader';
import { getDrawerContainer } from 'components/Pagelayout/PageLayout';
import { useDrawerData } from './useDrawerData';
import { Product } from './product';
import styles from './styles.scss';

interface Props {
  product: IRelatedProduct;
  isOpen: boolean;
  onClose: () => void;
  title: string;
}

export const DrawerProduct = ({ title, product: { productId, url }, isOpen, onClose }: Props) => {
  const { data, state, ...drawerData } = useDrawerData({ productId, url, isOpen });

  return (
    <RedDrawer
      noPadding
      title={title}
      onClose={onClose}
      isOpen={isOpen}
      container={getDrawerContainer}
    >
      <div className={styles.content}>
        {data && <Product data={data} state={state} {...drawerData} />}
        {state.loading && <Spinner className={styles.spinner} loading />}
      </div>
    </RedDrawer>
  );
};
